import React, { useEffect, useState } from "react";
import {
	Button,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	FormGroup,
	Label,
	Input,
} from "reactstrap";
import { useFromUser } from "../stores/LocalStorageHelper";
import {
	displayError,
	displayPdf,
	getDcReportAndDefaultsByID,
	getDcReportByID,
	getPdf,
	saveDefaults,
} from "../api/FormsAPI";
import Swal from "sweetalert2";
import { saveSuccessAlert } from "../utils/alertUtils";

const ReceiptButton = ({
	paymentId,
	accountID,
	options,
	dcReportDefault,
	setOptions,
	setDcReportDefault,
}) => {
	const dealerID = useFromUser("dealerID");
	const locationID = useFromUser("locationID");
	const username = useFromUser("lastName") + " " + useFromUser("firstName");

	// State for modal and checkbox values
	const [modalOpen, setModalOpen] = useState(false);
	const [localOptions, setLocalOptions] = useState(options);

	// Sync local options with parent options when they change
	useEffect(() => {
		setLocalOptions(options);
	}, [options]);

	// Toggle modal visibility
	const toggleModal = () => setModalOpen(!modalOpen);

	// Handle checkbox change - only update local state
	const handleCheckboxChange = (e) => {
		setLocalOptions({
			...localOptions,
			[e.target.name]: e.target.checked,
		});
	};

	// Handle print with selected options
	const handlePrint = () => {
		const body = {
			dcReportID: 512,
			params: {
				dealerID,
				locationID,
				paymentID: paymentId,
				cashier: username,
				...localOptions,
			},
		};

		getPdf(body).then(
			(response) => {
				displayPdf(response);
				Swal.close();
				toggleModal(); // Close modal after submission
			},
			(err) => {
				displayError(err);
			}
		);
	};

	const handleSave = () => {
		const defaults = JSON.stringify(localOptions);
		const defObj = {
			id: dcReportDefault?.defaultsID || null,
			dealerID: dealerID,
			locationID: locationID,
			dcReportID: 512,
			defaults: defaults,
		};
		saveDefaults(defObj).then(
			(response) => {
				setOptions(localOptions); // Sync back to parent
				setDcReportDefault(response.data.content);
				saveSuccessAlert();
			},
			(err) => {
				displayError(err);
			}
		);
	};

	return (
		<>
			<Button onClick={toggleModal}>Print</Button>

			<Modal isOpen={modalOpen} toggle={toggleModal}>
				<ModalHeader toggle={toggleModal}>Select Receipt Options</ModalHeader>
				<ModalBody>
					<FormGroup check>
						<Label check>
							<Input
								type="checkbox"
								name="showLoanBalans"
								checked={localOptions.showLoanBalans}
								onChange={handleCheckboxChange}
								style={{ marginRight: "8px" }} // Adds space without CSS file
							/>
							Show Loan Balance
						</Label>
					</FormGroup>
					<FormGroup check>
						<Label check>
							<Input
								type="checkbox"
								name="showPastDue"
								checked={localOptions.showPastDue}
								onChange={handleCheckboxChange}
								style={{ marginRight: "8px" }}
							/>
							Show Past Due
						</Label>
					</FormGroup>
					<FormGroup check>
						<Label check>
							<Input
								type="checkbox"
								name="showPayoff"
								checked={localOptions.showPayoff}
								onChange={handleCheckboxChange}
								style={{ marginRight: "8px" }}
							/>
							Show Payoff
						</Label>
					</FormGroup>
					<FormGroup check>
						<Label check>
							<Input
								type="checkbox"
								name="showPickupBal"
								checked={localOptions.showPickupBal}
								onChange={handleCheckboxChange}
								style={{ marginRight: "8px" }}
							/>
							Show Pickup Balance
						</Label>
					</FormGroup>
					<FormGroup check>
						<Label check>
							<Input
								type="checkbox"
								name="showPreviousBal"
								checked={localOptions.showPreviousBal}
								onChange={handleCheckboxChange}
								style={{ marginRight: "8px" }}
							/>
							Show Previous Balance
						</Label>
					</FormGroup>
					<FormGroup check>
						<Label check>
							<Input
								type="checkbox"
								name="showPaidThroughDate"
								checked={localOptions.showPaidThroughDate}
								onChange={handleCheckboxChange}
								style={{ marginRight: "8px" }}
							/>
							Show Paid Through Date
						</Label>
					</FormGroup>
				</ModalBody>
				<ModalFooter className="justify-content-between">
					<Button onClick={handleSave}>Save as Default</Button>
					<div>
						<Button color="primary" onClick={handlePrint}>
							Print
						</Button>
						<Button color="secondary" onClick={toggleModal}>
							Cancel
						</Button>
					</div>
				</ModalFooter>
			</Modal>
		</>
	);
};

export default ReceiptButton;
